module.exports = __webpack_public_path__ + "static/media/extraOptionAvailable.b04d0cc9.png";